import { render, staticRenderFns } from "./NpButton.vue?vue&type=template&id=1cdb19ac&"
import script from "./NpButton.vue?vue&type=script&lang=ts&"
export * from "./NpButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports